import React, { useEffect, useState } from "react";
import useTermPeriod from "../../../../hooks/useTermPeriod";
import styles from "../css/AttendanceStatisticsTable.module.css";
import { useTranslation } from "react-i18next";
import useFlexibleData from "../../../../hooks/useFlexibleData";

export default function AttendanceStatisticsTable({
  rows,
  attendanceRecord,
  organSettingInfo,
  selectedMonth,
  conditions,
  attendanceMode = "default",
  additionalAttendance,
}) {
  const {
    termPeriodQuery: { data: termPeriodData },
  } = useTermPeriod(conditions);

  const {
    flexibleDataQuery: { data: flexibleData },
  } = useFlexibleData({
    schoolid: conditions?.schoolid,
    main_category: "schoolSetting",
  });

  const [thisTerm, setThisTerm] = useState([]);
  const { t } = useTranslation();
  const isAdditionalMode = attendanceMode === "additional";
  const effectiveAdditionalAttendance =
    additionalAttendance || flexibleData?.[0]?.data_value?.additionalAttendance;
  const additionalOptions = Array.isArray(effectiveAdditionalAttendance?.options)
    ? effectiveAdditionalAttendance.options
    : [];
  const firstAdditionalValue =
    additionalOptions.find((option) => option !== "") || "";
  const attendanceConfig = isAdditionalMode
    ? {
        statusKey: "additional_attendance",
        memoKey: "additional_memo",
      }
    : {
        statusKey: "attendance_status",
        memoKey: "memo",
      };
  const showGschool369 =
    !isAdditionalMode &&
    flexibleData &&
    flexibleData.length > 0 &&
    flexibleData[0].data_value?.gschool;

  const getRecordStatus = (record) => record?.[attendanceConfig.statusKey] || "";
  const getRecordMemo = (record) => record?.[attendanceConfig.memoKey] || "";
  const isCountableStatus = (status) => {
    if (!status) return false;
    if (isAdditionalMode) return true;

    return status !== "질결" && status !== "무결" && status !== "기결";
  };

  useEffect(() => {
    if (termPeriodData && organSettingInfo.schoolYearId) {
      // const filtered = termPeriodData.filter(
      //   (r) =>
      //     r.school_year_id.toString() ===
      //     organSettingInfo.schoolYearId.toString()
      // );
      // console.log("filtered", filtered);

      let filteredPeriod = [];
      let hierarchyOnePeriod = [];
      let hierarchyTwoPeriod = [];

      //hierarchy와 일치하는 것이 있으면 그것만 나오고, 일치하는 것이 없으면 전체만 나오도록...

      filteredPeriod = termPeriodData.filter(
        (r) =>
          r.school_year_id.toString() ===
          organSettingInfo.schoolYearId.toString(),
      );

      hierarchyOnePeriod = filteredPeriod.filter(
        (r) =>
          r.applied_hierarchy_one !== null &&
          r.applied_hierarchy_one === Number(organSettingInfo.hierarchyOneId),
      );

      if (hierarchyOnePeriod.length > 0) {
        filteredPeriod = hierarchyOnePeriod;
      } else {
        filteredPeriod = filteredPeriod.filter(
          (r) => r.applied_hierarchy_one === null,
        );
      }

      // console.log("중간 filteredPeriod", filteredPeriod);
      if (organSettingInfo.hierarchyTwoId) {
        hierarchyTwoPeriod = filteredPeriod.filter(
          (r) =>
            r.applied_hierarchy_two !== null &&
            r.applied_hierarchy_two === Number(organSettingInfo.hierarchyTwoId),
        );

        if (hierarchyTwoPeriod.length > 0) {
          filteredPeriod = hierarchyTwoPeriod;
        } else {
          filteredPeriod = filteredPeriod.filter(
            (r) => r.applied_hierarchy_two === null,
          );
        }
      }
      if (filteredPeriod.length > 0) {
        filteredPeriod = filteredPeriod.sort((a, b) => {
          // hierarchy_two_name이 "전체"일 경우 우선 정렬
          if (
            a.hierarchy_two_name === "전체" &&
            b.hierarchy_two_name !== "전체"
          ) {
            return -1; // a가 b보다 앞에 오도록
          } else if (
            a.hierarchy_two_name !== "전체" &&
            b.hierarchy_two_name === "전체"
          ) {
            return 1; // b가 a보다 앞에 오도록
          }

          // hierarchy_one_name이 "전체"일 경우 우선 정렬
          if (
            a.hierarchy_one_name === "전체" &&
            b.hierarchy_one_name !== "전체"
          ) {
            return -1;
          } else if (
            a.hierarchy_one_name !== "전체" &&
            b.hierarchy_one_name === "전체"
          ) {
            return 1;
          }

          return 0; // 그 외의 경우 순서 유지
        });
      }

      // const thisTermDates =
      //   filteredPeriod.length > 0 ? filteredPeriod[0] : null;

      // console.log("filteredPeriod this term", filteredPeriod);

      setThisTerm(filteredPeriod);
    }
  }, [
    organSettingInfo.hierarchyOneId,
    organSettingInfo.hierarchyTwoId,
    organSettingInfo.schoolYearId,
    termPeriodData,
  ]);

  //   const schoolYear = "2024";
  //   const selectedMonth = "3";

  const getColorForStatus = (status) => {
    if (status) {
      if (isAdditionalMode) {
        return status === firstAdditionalValue ? "#B3E2FD" : "#FFFFE0";
      }

      if (status.includes("출")) {
        return "#B3E2FD"; // Purple for status containing "지"
      } else if (
        status.includes("결") &&
        !status.includes("출") &&
        !status.includes("과")
      ) {
        return "#FFD4E1"; // Purple for status containing "지"
      } else if (
        (status.includes("지") || status.includes("조")) &&
        !status.includes("출") &&
        !status.includes("과")
      ) {
        return "#FFFFE0";
      } else if (Number(status) >= 9) {
        return "#FF9781"; // 빨간색 (9이상)
      } else if (Number(status) >= 6) {
        return "#FFD38A"; // 주황색 (6이상)
      } else if (Number(status) >= 3) {
        return "#FFFC98"; // 노란색 (3이상)
      }
    } else {
      return "#FFFFFF";
    }
  };

  // selectedMonth가 "YYYY-MM" 형식 (예: "2024-02")이므로 파싱해서 사용
  const daysInMonth = (selectedYearMonth) => {
    if (!selectedYearMonth || typeof selectedYearMonth !== "string") {
      return 0;
    }

    const [yearStr, monthStr] = selectedYearMonth.split("-");
    const year = parseInt(yearStr, 10);
    const month = parseInt(monthStr, 10);

    if (isNaN(year) || isNaN(month)) {
      return 0;
    }

    const days = new Date(year, month, 0).getDate();
    return days > 0 ? days : 0;
  };

  // selectedMonth에서 년도와 월 추출하는 헬퍼
  const getYearMonthFromSelected = () => {
    if (!selectedMonth || typeof selectedMonth !== "string") {
      return { year: null, month: null };
    }
    const [yearStr, monthStr] = selectedMonth.split("-");
    return {
      year: parseInt(yearStr, 10),
      month: parseInt(monthStr, 10),
    };
  };

  const { year: selectedYear, month: selectedMonthNum } =
    getYearMonthFromSelected();

  return (
    <div className="overflow-auto mb-4 print-no-overflow">
      <table
        className={`tableStyle table table-bordered table-sm text-center ${styles.tableStyle}`}
      >
        <thead>
          <tr>
            {/* Generate table headers for all days of the month */}
            <th
              style={{ minWidth: "25px", width: "30px", maxWidth: "30px" }}
              className="fixed-column"
            >
              No.
            </th>
            <th
              style={{ minWidth: "35px", width: "35px", maxWidth: "35px" }}
              className="fixed-column"
            >
              {organSettingInfo.schoolYear}
            </th>
            {thisTerm &&
              thisTerm?.map((term) => (
                <React.Fragment key={term.id}>
                  <th
                    key={term.id}
                    style={{
                      minWidth: "35px",
                      width: "35px",
                      maxWidth: "35px",
                    }}
                    className="fixed-column"
                  >
                    {term.term_name + term.term_category}
                  </th>

                  {showGschool369 && (
                    <th
                      style={{
                        minWidth: "30px",
                        width: "30px",
                        maxWidth: "30px",
                      }}
                      className="fixed-column"
                    >
                      369
                    </th>
                  )}
                </React.Fragment>
              ))}
            <th
              style={{ minWidth: "30px", width: "30px", maxWidth: "30px" }}
              className="fixed-column"
            >
              {selectedYear
                ? `${String(selectedYear).slice(2)}-${selectedMonthNum}월`
                : ""}
            </th>
            <th
              style={{ minWidth: "50px", width: "50px", maxWidth: "50px" }}
              className="fixed-column"
            >
              {t("common.user.fullname") || "이름"}
            </th>
            {flexibleData &&
              flexibleData.length > 0 &&
              flexibleData[0].data_value?.attendanceOtherName && (
                <th
                  style={{ minWidth: "50px", width: "50px", maxWidth: "50px" }}
                  className="fixed-column"
                >
                  {t("common.user.otherName") || "다른 이름"}
                </th>
              )}
            {[...Array(Math.max(0, daysInMonth(selectedMonth))).keys()].map(
              (day) => (
                <th
                  style={{ minWidth: "18px", width: "18px" }}
                  key={day}
                  className="day-column"
                >
                  {day + 1}
                </th> // Day of the month
              ),
            )}
          </tr>
        </thead>
        <tbody>
          {rows &&
            attendanceRecord &&
            rows.map((student, index) => {
              // console.log("attendanceRecord", attendanceRecord);

              const filteredFirst = attendanceRecord.filter((r) => {
                return r.username === student.username;
              });

              // console.log("filtered1", filtered);
              // selectedMonth는 "YYYY-MM" 형식 (예: "2024-02")
              const filteredByMonth = filteredFirst.filter((r) => {
                const date = new Date(r.date);
                const recordYearMonth = `${date.getFullYear()}-${String(
                  date.getMonth() + 1,
                ).padStart(2, "0")}`;
                return (
                  recordYearMonth === selectedMonth &&
                  getRecordStatus(r) !== ""
                );
              });

              const yearCount = filteredFirst.filter(
                (r) => isCountableStatus(getRecordStatus(r)),
              );

              // console.log("attendanceRecord", attendanceRecord);

              // console.log("yearCount", filtered);
              // console.log("filteredByMonth", filteredByMonth);
              return (
                <tr key={index}>
                  <th className="fixed-column">{index + 1}</th>
                  <th className="fixed-column">{yearCount.length}</th>
                  {thisTerm.map((term) => {
                    const termCount = filteredFirst.filter(
                      (r) =>
                        isCountableStatus(getRecordStatus(r)) &&
                        r.date >= term.start_date &&
                        r.date <= term.end_date,
                    );

                    const gschool369 = filteredFirst.filter(
                      (r) =>
                        (getRecordStatus(r) === "무결" ||
                          getRecordStatus(r) === "무조" ||
                          getRecordStatus(r) === "무지") &&
                        r.date >= term.start_date &&
                        r.date <= term.end_date,
                    );

                    return (
                      <React.Fragment key={term.id}>
                        <th key={term.id} className="fixed-column">
                          {termCount.length}
                        </th>
                        {showGschool369 && (
                          <td
                            className="fixed-column"
                            style={{
                              backgroundColor: getColorForStatus(
                                gschool369.length.toString(),
                              ),
                            }}
                          >
                            {gschool369.length}
                          </td>
                        )}
                      </React.Fragment>
                    );
                  })}
                  <th className="fixed-column">
                    {
                      filteredByMonth.filter((r) => {
                        return isCountableStatus(getRecordStatus(r));
                      }).length
                    }
                  </th>
                  <td className="align-middle fixed-column">
                    {student.fullname}
                  </td>
                  {flexibleData &&
                    flexibleData.length > 0 &&
                    flexibleData[0].data_value?.attendanceOtherName && (
                      <td className="align-middle fixed-column">
                        {student.otherName}
                      </td>
                    )}
                  {[...Array(daysInMonth(selectedMonth)).keys()].map((day) => {
                    const filtered = filteredByMonth.find((r) => {
                      const date = new Date(r.date).getDate();
                      // console.log("date", date);
                      // console.log("day", day);
                      return date === day + 1;
                    });

                    // console.log("filteredByMonth", filteredByMonth);
                    // console.log("filtered2", filtered);
                    // console.log("day", day);
                    // console.log("day + 1", day + 1);

                    return (
                      <td
                        key={`${filtered?.id}-${day}`}
                        title={getRecordMemo(filtered)}
                        name={day + 1}
                        id={filtered?.date}
                        className="day-column"
                        style={{
                          backgroundColor: getColorForStatus(
                            getRecordStatus(filtered),
                          ),
                        }}
                      >
                        {getRecordStatus(filtered)}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
}
